export enum ESteps {
    SpeedAndTv = 1,
    Subscriptions = 2,
    Equipment = 3,
    FillAddress = 4,
    FillContacts = 5,
    CreateAgreement = 6,
    SelectVisitData = 7,

    Final = 8,
}
